export class TeamCard {
    target = null;
    toggled = false;

    constructor(target) {
      this.target = target;
      this.toggled = false;
      this.target.addEventListener('click', this.onClick.bind(this));
    }
  
    onClick() {
        this.toggled = !this.toggled;

        if(this.toggled){
            this.target.closest('.card').classList.add('detailed');
        }
        else{
            this.target.closest('.detailed').classList.remove('detailed');
        }
    }
  }
  